import CanShow from "./CanShow";
import Donors from "@/features/donors/donors/Index";
import ShowDonor from "@/features/donors/donors/Show";
import CustomersCampaigns from "@/features/donors/customersCampaigns/Index.jsx";
import Ratings from "@/features/donors/ratings/Index";

export const donorsRoutes = [
  {
    path: "/donors",
    element: <CanShow page={<Donors />} ifHas={["donors"]} />,
  },
  {
    path: "/donors/:id",
    element: <CanShow page={<ShowDonor />} ifHas={["donors"]} />,
  },
  {
    path: "/customers-campaigns",
    element: (
      <CanShow page={<CustomersCampaigns />} ifHas={["customerCampaigns"]} />
    ),
  },
  {
    path: "/ratings",
    element: <CanShow page={<Ratings />} ifHas={["ratings"]} />,
  },
];
